module.exports = __webpack_public_path__ + "img/07關鍵字.acba2d9a.jpg";